<dodo-request-callback-dialog-layout (close)="_closeDialog()">
</dodo-request-callback-dialog-layout>

<iframe
	_ngcontent-c45=""
	[src]="_callbackFormUrl"
	id="request-callback-iframe"
	allowtransparency="true"
	scrolling="no"
	width="320px"
	height="615px"
	frameborder="0"
	style="border: none; text-align: center; margin-top:-30px"
>
</iframe>
